import { useMemo } from "react";
import { USER_ROLE } from "../../commons/enum";
import { useCompanyInfo, useCompanyInfoById } from "../../hooks";
import { useMyInfo } from "../../hooks/user.hooks.ts";
import { checkIsDemoClient } from "../../utils";
import { navigateToDomainWithLocalStorageData } from "../../utils/domain-navigation";
import { getAllValueLocationStorage } from "../../utils/locastorage-utils";

/**
 * DashboardLogicWrapper is a centralized place for dashboard-wide logic.
 * It is placed inside Layout's contexts to make it easier to use `useContext`
 */
export const DashboardLogicWrapper = ({ children }) => {
  const { data: myInfo, isSuccess: isGetMyInfoSuccess } = useMyInfo();
  const { data: companyInfo, isSuccess: isGetCompanyInfoSuccess } = useCompanyInfo();
  const { data: companyInfoById, isSuccess: isGetCompanyInfoByIdSuccess } = useCompanyInfoById(
    myInfo?.companyId
  );

  const isDemoClient = checkIsDemoClient();
  const isGettingDataSuccess = useMemo(() => {
    return (
      (myInfo?.companyId ? isGetCompanyInfoByIdSuccess : true) &&
      isGetMyInfoSuccess &&
      isGetCompanyInfoSuccess
    );
  }, [myInfo?.companyId, isGetCompanyInfoByIdSuccess, isGetMyInfoSuccess, isGetCompanyInfoSuccess]);

  const isUserBelongToCompany = useMemo(() => {
    const isRootCompany = myInfo?.companyId ? myInfo?.companyId === companyInfo?.id : true;
    return isGettingDataSuccess ? isRootCompany : false;
  }, [isGettingDataSuccess, companyInfo?.id, myInfo?.companyId]);

  if (!isGettingDataSuccess) return null;

  if (myInfo.userRole === USER_ROLE.ADMIN || isUserBelongToCompany || isDemoClient) {
    return <div className="my-account-container">{children}</div>;
  }

  const localStorageData = getAllValueLocationStorage();

  navigateToDomainWithLocalStorageData(companyInfoById?.domain, localStorageData);

  return null;
};
